// For Firebase JS SDK v7.20.0 and later, measurementId is optional

const firebaseConfig = {
  apiKey: "AIzaSyBItMi6jHdmb1-tUdkoEaUwlyTZBXYxulI",
  authDomain: "m-fourty-one-ema-jhon-react.firebaseapp.com",
  projectId: "m-fourty-one-ema-jhon-react",
  storageBucket: "m-fourty-one-ema-jhon-react.appspot.com",
  messagingSenderId: "117867642993",
  appId: "1:117867642993:web:506a62140be99bc26d9bd0",
  measurementId: "G-16TW05KB8K"
};

export default firebaseConfig;

